<div class="row g-0">
  <div class="col-md-6 col-xxl-3 mb-3 pe-md-2">
    <div class="card h-md-100 ecommerce-card-min-width">
      <div class="card-header pb-0">
        <h6 class="mb-0 mt-2 d-flex align-items-center">سرجمع فروش<span class="ms-1 text-400" data-bs-toggle="tooltip" data-bs-placement="top" title="Calculated according to last week's sales"><span
              class="far fa-question-circle" data-fa-transform="shrink-1"></span></span></h6>
      </div>
      <div class="card-body d-flex flex-column justify-content-end">
        <div class="row">
          <div class="col">
            <p class="font-sans-serif lh-1 mb-1 fs-1">19,751,205,219</p><span class="badge badge-soft-success rounded-pill fs--2">+4.5%</span>
          </div>
          <div class="col-auto ps-0">
            <div class="echart-bar-weekly-sales h-100" style="user-select: none; position: relative;">
              <app-chart [ido]="'2021082509422707430'"></app-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6 col-xxl-3 mb-3 ps-md-2 pe-xxl-2">
    <div class="card h-md-100">
      <div class="card-header pb-0">
        <h6 class="mb-0 mt-2">فروش ماهانه</h6>
      </div>
      <div class="card-body d-flex flex-column justify-content-end">
        <div class="row justify-content-between">
          <div class="col-auto align-self-end">
            <div class="fs-1 fw-normal font-sans-serif text-700 lh-1 mb-1">1,491,798,920,448</div><span class="badge rounded-pill fs--2 bg-200 text-success"><span class="fas fa-caret-up me-1"></span>+16.53%</span>
          </div>
          <div class="col-auto ps-0 mt-n4">
            <div class="echart-default-total-order h-100" style="user-select: none; position: relative;">
              <app-chart [ido]="'2021082513324929071'"></app-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6 col-xxl-3 mb-3 pe-md-2 ps-xxl-2">
    <div class="card h-md-100">
      <div class="card-body">
        <div class="row h-100 justify-content-between g-0">
          <div class="col-5 col-sm-6 col-xxl pe-2">
            <h6 class="mt-1">خرید تامین کنندگان - دی ماه</h6>
            <div class="fs--2 mt-3">
              <div class="d-flex flex-between-center mb-1">
                <div class="d-flex align-items-center"><span class="dot" style="background-color: #e6b928;"></span><span class="fw-semi-bold">فیاض رستمی دامناب</span></div>
                <div>2.80%</div>
              </div>
              <div class="d-flex flex-between-center mb-1">
                <div class="d-flex align-items-center"><span class="dot" style="background-color: #1fe630;"></span><span class="fw-semi-bold">بین المللی پارسیان پخش بیژن-سلولزی</span></div>
                <div>2.60%</div>
              </div>
              <div class="d-flex flex-between-center mb-1">
                <div class="d-flex align-items-center"><span class="dot" style="background-color: #1fdfe6;"></span><span class="fw-semi-bold">پخش پدیده پایدار</span></div>
                <div>2.57%</div>
              </div>
            </div>
          </div>
          <div class="col-auto position-relative">
            <div class="echart-market-share">
              <app-chart [ido]="'2021082514121511955'"></app-chart>
            </div>
            <div class="position-absolute top-50 start-50 translate-middle text-dark fs-2" style="width: 60px; margin-right: -50px;">148G</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6 col-xxl-3 mb-3 ps-md-2">
    <div class="card h-md-100">
      <div class="card-header d-flex flex-between-center pb-0">
        <h6 class="mb-0">آب و هوا</h6>
        <div class="dropdown font-sans-serif btn-reveal-trigger">
          <button class="btn btn-link text-600 btn-sm dropdown-toggle dropdown-caret-none btn-reveal" type="button" id="dropdown-weather-update" data-bs-toggle="dropdown" data-boundary="viewport"
            aria-haspopup="true" aria-expanded="false"><span class="fas fa-ellipsis-h fs--2"></span></button>
          <div class="dropdown-menu dropdown-menu-end border py-2" aria-labelledby="dropdown-weather-update"><a class="dropdown-item" href="#!">مشاهده</a><a class="dropdown-item" href="#!">خروجی</a>
            <div class="dropdown-divider"></div><a class="dropdown-item text-danger" href="#!">حذف</a>
          </div>
        </div>
      </div>
      <div class="card-body pt-2">
        <div class="row g-0 h-100 align-items-center">
          <div class="col">
            <div class="d-flex align-items-center"><img class="me-3" src="assets/img/icons/weather-icon.png" alt="" height="60" />
              <div>
                <h6 class="mb-2">شهرستان کرج</h6>
                <div class="fs--2 fw-semi-bold">
                  <div class="text-warning">نیمه ابری</div>Precipitation: 50%
                </div>
              </div>
            </div>
          </div>
          <div class="col-auto text-center ps-2">
            <div class="fs-4 fw-normal font-sans-serif text-primary mb-1 lh-1">9&deg;</div>
            <div class="fs--1 text-800">11&deg; / 2&deg;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row g-0">
  <div class="col-lg-6 pe-lg-2 mb-3">
    <div class="card overflow-hidden" style="height: 100%;">
      <div class="card-header bg-light">
        <div class="row align-items-center">
          <div class="col">
            <h6 class="mb-0">سرجمع فروش به تفکیک شعب</h6>
          </div>
          <div class="col-auto text-center pe-card">
            <select class="form-select form-select-sm">
              <option>روز جاری</option>
              <option>دیروز</option>
              <option>پریروز</option>
            </select>
          </div>
        </div>
      </div>
      <div class="card-body p-0">
        <app-grid [ido]="'2021091110073093781'"></app-grid>
      </div>
      <div class="card-footer bg-light p-0"><a class="btn btn-sm btn-link d-block w-100 py-2" [routerLink]="['/home', 'summary_daily']">همه شعب</a></div>
    </div>
  </div>
  <div class="col-lg-6 ps-lg-2 mb-3">
    <div class="card" style="height: 100%;">
      <div class="card-header">
        <div class="row flex-between-center">
          <div class="col-auto">
            <h6 class="mb-0">نمودار نرخ رشد ماهانه</h6>
          </div>
          <div class="col-auto d-flex">
            <select class="form-select form-select-sm select-month me-2">
              <option value="0">فروردین</option>
              <option value="1">اردیبهشت</option>
              <option value="2">خرداد</option>
              <option value="3">تیر</option>
              <option value="4">مرداد</option>
              <option value="5">شهریور</option>
              <option value="6">مهر</option>
              <option value="7">آبان</option>
              <option value="8">آذر</option>
              <option value="9">دی</option>
              <option value="10">بهمن</option>
              <option value="11">اسفند</option>
            </select>
            <div class="dropdown font-sans-serif btn-reveal-trigger">
              <button class="btn btn-link text-600 btn-sm dropdown-toggle dropdown-caret-none btn-reveal" type="button" id="dropdown-total-sales" data-bs-toggle="dropdown" data-boundary="viewport"
                aria-haspopup="true" aria-expanded="false"><span class="fas fa-ellipsis-h fs--2"></span></button>
              <div class="dropdown-menu dropdown-menu-end border py-2" aria-labelledby="dropdown-total-sales"><a class="dropdown-item" href="#!">مشاهده</a><a class="dropdown-item" href="#!">خروجی</a>
                <div class="dropdown-divider"></div><a class="dropdown-item text-danger" href="#!">حذف</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body h-100 pe-0" style="min-height: 300px;">
        <!-- <div class="echart-line-total-sales h-100" data-echart-responsive="true"></div> -->
        <app-chart [ido]="'2019010209174990030'"></app-chart>
      </div>
    </div>
  </div>
</div>
<div class="row g-0">
  <div class="col-lg-6 col-xl-7 col-xxl-8 mb-3 pe-lg-2 mb-3">
    <div class="card" style="height: 100%;">
      <div class="card-body d-flex align-items-center">
        <div class="w-100">
          <h6 class="mb-3 text-800">فروش به تفکیک گروه کالایی</h6>
          <div class="progress mb-3 rounded-3" style="height: 10px;">
            <div class="progress-bar bg-progress-gradient border-end border-white border-2" role="progressbar" style="background-color: #014db1 !important; width: 32.32%" title="484,975,642,829"
              aria-valuenow="32.32" aria-valuemin="0" aria-valuemax="100"></div>
            <div class="progress-bar bg-info border-end border-white border-2" role="progressbar" style="background-color: #1fdfe6 !important; width: 20.28%" title="304,330,157,507" aria-valuenow="20.28"
              aria-valuemin="0" aria-valuemax="100"></div>
            <div class="progress-bar bg-success border-end border-white border-2" role="progressbar" style="background-color: #1fe6a4 !important; width: 18.02%" title="270,415,864,251" aria-valuenow="18.02"
              aria-valuemin="0" aria-valuemax="100"></div>
            <div class="progress-bar bg-success border-end border-white border-2" role="progressbar" style="background-color: #1fe630 !important; width: 14.45%" title="216,797,715,266" aria-valuenow="14.45"
              aria-valuemin="0" aria-valuemax="100"></div>
            <div class="progress-bar bg-success border-end border-white border-2" role="progressbar" style="background-color: #bbe61f !important; width: 7.23%" title="108,534,784,349" aria-valuenow="07.23"
              aria-valuemin="0" aria-valuemax="100"></div>
            <div class="progress-bar bg-success border-end border-white border-2" role="progressbar" style="background-color: #e6b928 !important; width: 4.1%" title="61,582,022,521" aria-valuenow="4.1"
              aria-valuemin="0" aria-valuemax="100"></div>
            <div class="progress-bar bg-success border-end border-white border-2" role="progressbar" style="background-color: #e6961f !important; width: 3.4%" title="51,043,710,787" aria-valuenow="3.4"
              aria-valuemin="0" aria-valuemax="100"></div>
            <div class="progress-bar bg-success border-end border-white border-2" role="progressbar" style="background-color: #e63d1f !important; width: 0.18%" title="2,696,764,890" aria-valuenow="0.18"
              aria-valuemin="0" aria-valuemax="100"></div>
            <!-- <div class="progress-bar bg-200" role="progressbar" style="width: 28.14%" aria-valuenow="28.14" aria-valuemin="0" aria-valuemax="100"></div> -->
          </div>
          <div class="row fs--1 fw-semi-bold text-500 g-0">
            <div class="col-auto d-flex align-items-center pe-3"><span style="background-color:#014db1 !important" class="dot bg-primary"></span><span>مواد غذایی</span><span
                class="d-none d-md-inline-block d-lg-none d-xxl-inline-block"></span></div>
            <div class="col-auto d-flex align-items-center pe-3"><span style="background-color:#1fdfe6 !important" class="dot bg-info"></span><span>کالای فله</span><span
                class="d-none d-md-inline-block d-lg-none d-xxl-inline-block"></span></div>
            <div class="col-auto d-flex align-items-center pe-3"><span style="background-color:#1fe630 !important" class="dot bg-success"></span><span>پروتئین، لبنیات</span><span
                class="d-none d-md-inline-block d-lg-none d-xxl-inline-block"></span></div>
            <div class="col-auto d-flex align-items-center pe-3"><span style="background-color:#1fe6a4 !important" class="dot bg-warning"></span><span>زیبایی و سلامت</span><span
                class="d-none d-md-inline-block d-lg-none d-xxl-inline-block"></span></div>
            <div class="col-auto d-flex align-items-center pe-3"><span style="background-color:#bbe61f !important" class="dot bg-default"></span><span>شوینده</span><span
                class="d-none d-md-inline-block d-lg-none d-xxl-inline-block"></span></div>
            <div class="col-auto d-flex align-items-center pe-3"><span style="background-color:#e6b928 !important" class="dot bg-dark"></span><span>نوشیدنی</span><span
                class="d-none d-md-inline-block d-lg-none d-xxl-inline-block"></span></div>
            <div class="col-auto d-flex align-items-center pe-3"><span style="background-color:#e6961f !important" class="dot bg-light"></span><span>خانه و سبک زندگی</span><span
                class="d-none d-md-inline-block d-lg-none d-xxl-inline-block"></span></div>
            <div class="col-auto d-flex align-items-center pe-3"><span style="background-color:#e63d1f !important" class="dot bg-success"></span><span>مد و پوشاک</span><span
                class="d-none d-md-inline-block d-lg-none d-xxl-inline-block"></span></div>
            <!-- <div class="col-auto d-flex align-items-center"><span class="dot bg-200"></span><span>Free</span><span class="d-none d-md-inline-block d-lg-none d-xxl-inline-block">(576MB)</span></div> -->
          </div>
          <br>
          <br>
          <br>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6 col-xl-5 col-xxl-4 mb-3 ps-lg-2">
    <div class="card" style="height: 100%;">
      <div class="bg-holder bg-card" style="background-image:url(assets/img/icons/spot-illustrations/corner-1.png);">
      </div>
      <!--/.bg-holder-->

      <div class="card-body position-relative" style="padding-top:0">
        <h5 class="text-warning">تعداد استخدام/پایان کار هفته اخیر</h5>
        <!-- <p class="fs--1 mb-0">Your storage will be running out soon. Get more space and powerful productivity features.</p><a class="btn btn-link fs--1 text-warning mt-lg-3 ps-0" href="#!">Upgrade storage<span
            class="fas fa-chevron-right ms-1" data-fa-transform="shrink-4 down-1"></span></a> -->
        <app-chart [ido]="'2021090612172301262'"></app-chart>
      </div>
    </div>
  </div>
</div>
<div class="row g-0">
  <div class="col-lg-6 col-xl-6 pe-lg-2 mb-3">
    <div class="card overflow-hidden" style="height: 100%;">
      <div class="card-body p-0">
        <div class="table-responsive scrollbar">
          <app-grid [ido]="'2021091110042634281'"></app-grid>

        </div>
      </div>
      <div class="card-footer bg-light py-2">
        <div class="row flex-between-center">
          <div class="col-auto">
            <select class="form-select form-select-sm">
              <option>Last 7 days</option>
              <option>Last Month</option>
              <option>Last Year</option>
            </select>
          </div>
          <div class="col-auto"><a class="btn btn-sm btn-falcon-default" href="#!">View All</a></div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6 col-xl-6 ps-lg-2 mb-3">
    <div class="card">
      <div class="card-header d-flex flex-between-center bg-light py-2">
        <h6 class="mb-0">مقایسه هزینه</h6><a class="py-1 fs--1 font-sans-serif" href="#!">مشاهده همه</a>
      </div>
      <div class="card-body pb-0" style="height: 420px;">
        <app-chart [ido]="'2021091111540471080'"></app-chart>
      </div>
    </div>
  </div>
</div>
<div class="row g-0">
  <div class="col-sm-6 col-xxl-3 pe-sm-2 mb-3 mb-xxl-0">
    <div class="card">
      <div class="card-header d-flex flex-between-center bg-light py-2">
        <h6 class="mb-0">استخدام و ترک کار</h6>
        <div class="dropdown font-sans-serif btn-reveal-trigger">
          <button class="btn btn-link text-600 btn-sm dropdown-toggle dropdown-caret-none btn-reveal" type="button" id="dropdown-active-user" data-bs-toggle="dropdown" data-boundary="viewport" aria-haspopup="true"
            aria-expanded="false"><span class="fas fa-ellipsis-h fs--2"></span></button>
          <div class="dropdown-menu dropdown-menu-end border py-2" aria-labelledby="dropdown-active-user"><a class="dropdown-item" href="#!">View</a><a class="dropdown-item" href="#!">Export</a>
            <div class="dropdown-divider"></div><a class="dropdown-item text-danger" href="#!">حذف</a>
          </div>
        </div>
      </div>
      <div class="card-body py-2" style="padding: 0;">
        <app-grid [ido]="'2021091111531133281'"></app-grid>
      </div>
      <div class="card-footer bg-light p-0"><a class="btn btn-sm btn-link d-block w-100 py-2" [routerLink]="['/home', 'personnel_cooperation_moves']">همه پرسنل</a></div>
    </div>
  </div>
  <div class="col-sm-6 col-xxl-3 ps-sm-2 order-xxl-1 mb-3 mb-xxl-0">
    <div class="card h-100">
      <div class="card-header bg-light d-flex flex-between-center py-2">
        <h6 class="mb-0">نسبت تحقق فروش به هدف</h6>
        <div class="dropdown font-sans-serif btn-reveal-trigger">
          <button class="btn btn-link text-600 btn-sm dropdown-toggle dropdown-caret-none btn-reveal" type="button" id="dropdown-bandwidth-saved" data-bs-toggle="dropdown" data-boundary="viewport"
            aria-haspopup="true" aria-expanded="false"><span class="fas fa-ellipsis-h fs--2"></span></button>
          <div class="dropdown-menu dropdown-menu-end border py-2" aria-labelledby="dropdown-bandwidth-saved"><a class="dropdown-item" href="#!">نمایش</a><a class="dropdown-item" href="#!">Export</a>
            <div class="dropdown-divider"></div><a class="dropdown-item text-danger" href="#!">حذف</a>
          </div>
        </div>
      </div>
      <div class="card-body d-flex flex-center flex-column h-100" style="user-select: none; position: relative;">
        <!-- <div class="progress-circle progress-circle-dashboard" data-options='{"color":"url(#gradient)","progress":93,"strokeWidth":5,"trailWidth":5}'></div>
        <div class="text-center mt-4">
          <h6 class="fs-0 mb-1"><span class="fas fa-check text-success me-1" data-fa-transform="shrink-2"></span>35.75 GB saved</h6>
          <p class="fs--1 mb-0">38.44 GB total bandwidth</p>
        </div> -->
        <app-chart [ido]="'2021090614485827381'"></app-chart>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <div class="text-center mt-4" style="display: none;">
          <h6 class="fs-0 mb-1"><svg class="svg-inline--fa fa-check fa-w-16 text-success me-1" data-fa-transform="shrink-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img"
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="" style="transform-origin: 0.5em 0.5em;">
              <g transform="translate(256 256)">
                <g transform="translate(0, 0)  scale(0.875, 0.875)  rotate(0 0 0)">
                  <path fill="currentColor"
                    d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                    transform="translate(-256 -256)"></path>
                </g>
              </g>
            </svg><!-- <span class="fas fa-check text-success me-1" data-fa-transform="shrink-2"></span> Font Awesome fontawesome.com -->35.75 GB saved</h6>
          <p class="fs--1 mb-0">38.44 GB total bandwidth</p>
        </div>
      </div>
      <div class="card-footer bg-light py-2">
        <div class="row flex-between-center">
          <div class="col-auto">
            <select class="form-select form-select-sm">
              <option>Last 6 Months</option>
              <option>Last Year</option>
              <option>Last 2 Year</option>
            </select>
          </div>
          <div class="col-auto"><a class="fs--1 font-sans-serif" href="#!">Help</a></div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xxl-6 px-xxl-2">
    <div class="card h-100">
      <div class="card-header bg-light py-2">
        <div class="row flex-between-center">
          <div class="col-auto">
            <h6 class="mb-0">مقایسه فروش و هدف</h6>
          </div>
          <div class="col-auto d-flex"><a class="btn btn-link btn-sm me-2" href="#!">View Details</a>
            <div class="dropdown font-sans-serif btn-reveal-trigger">
              <button class="btn btn-link text-600 btn-sm dropdown-toggle dropdown-caret-none btn-reveal" type="button" id="dropdown-top-products" data-bs-toggle="dropdown" data-boundary="viewport"
                aria-haspopup="true" aria-expanded="false"><span class="fas fa-ellipsis-h fs--2"></span></button>
              <div class="dropdown-menu dropdown-menu-end border py-2" aria-labelledby="dropdown-top-products"><a class="dropdown-item" href="#!">View</a><a class="dropdown-item" href="#!">Export</a>
                <div class="dropdown-divider"></div><a class="dropdown-item text-danger" href="#!">Remove</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body echart-bar-top-products h-100" style="min-height: 300px;">
        <!-- <div class="echart-bar-top-products h-100" data-echart-responsive="true"></div> -->
        <app-chart [ido]="'2021090610435053008'"></app-chart>
      </div>
    </div>
  </div>
</div>